import React from 'react';
import SVGLoader from './SVGLoader';

const PenIcon = props => {
  return (
    <SVGLoader {...props} viewboxWidth={140} viewboxHeight={140}>
      <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
        <path
          d="M15.067,3.986a.5.5,0,0,0-.354-.148h0a.5.5,0,0,0-.354.147L3.437,14.91a.5.5,0,0,0,0,.707l4.948,4.948a.5.5,0,0,0,.707,0L20.009,9.648a.5.5,0,0,0,0-.706Z"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        ></path>
        <path
          d="M2.43,16.8a.5.5,0,0,0-.489-.127.5.5,0,0,0-.351.364L.084,23.314a.5.5,0,0,0,.133.47.507.507,0,0,0,.47.132l6.272-1.5a.5.5,0,0,0,.237-.84Z"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        ></path>
        <path
          d="M23.2,2.924,21.077.8a2.5,2.5,0,0,0-3.532,0L16.127,2.217a.5.5,0,0,0,0,.707l4.95,4.949a.5.5,0,0,0,.707,0L23.2,6.454A2.5,2.5,0,0,0,23.2,2.924Z"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        ></path>
      </g>
    </SVGLoader>
  );
};

export default PenIcon;
